import React from 'react';
import useMyMenuHooks from './myMenu-hooks';
import { BusinessTypes } from '../../../../../../Interfaces/componentTypes';
import CustomDialog from '../../../../../../Components/Dialog/customDialog';
import styles from './myMenu.module.scss';

export interface IMyMenuProps {
  company_id: number,
  business_type: BusinessTypes,
  companyTitle: string,
  currencySymbol: string,
  template: null | string,
  onUpdate: () => void
};

const MyMenu: React.FC<IMyMenuProps> = (props) => {
  const {
    open,
    navRef,
    navItemRefs,
    PAGE_CONTENTS,
    activeContent,
    myMenuActions,
    dialogComponent,
    onClose,
    handleNavClick,
  } = useMyMenuHooks(props)
  return (
    <div className={styles.container}>
      <div className={styles.myMenuHeader} ref={navRef}>
        {myMenuActions.map((action, index) => (
          <div
            key={index}
            ref={(el) => (navItemRefs.current[index] = el)}
            className={`${styles.myMenuHeaderItem} ${activeContent === action.id! && styles.aciveItem}`}
            onClick={() => handleNavClick(index, action.id)}
          >
            <img src={action.icon} alt={`${action.icon}.svg`} />
            <p>{action.title}</p>
          </div>
        ))}
      </div>
      {PAGE_CONTENTS[activeContent]}
      <CustomDialog
        open={open}
        onClose={onClose}
        children={dialogComponent}
      />
    </div>
  )
}

export default MyMenu
